import {
  UI_DATA,
  CAMPAIGN_TYPES,
  NOTIFICATION_CHANNELS,
} from "../consts/Campaign";
import { CIP_FIELDS } from "../consts/CIP";
import { DEFAULT_FLOW, STEPPER, SYSTEM_NOTIFICATIONS_DEFAULT_FLOW, SYSTEM_NOTIFICATIONS_STEPPER } from "../consts/CampaignEdit";
import {
  CAMPAIGN,
  CONFIGURATIONS,
  DATA_SOURCE,
  DATA_SOURCE_TYPES,
  EXTERNAL_USER_OPTIONS_CONFIGS,
  MAPPING,
  NOTIFICATION,
  RECIPIENTS,
  TRIGGER,
} from "../consts/DBFields";
import {
  getCampaignType,
  getConfigurationFieldValues,
  getDateFromCron,
  getNotification,
  getRecipientsFieldValues,
} from "./campaign";
import { getChannel } from "./notification";
import moment from "moment";
import _ from "lodash";

// updates a notification at an index, or creates a notification if it doesn't exist
export const updateOrCreateNotification = (
  campaign,
  notificationIndex,
  newValue
) => {
  let notifications = campaign[CAMPAIGN.NOTIFICATIONS] || [];
  if (!notifications[notificationIndex]) {
    notifications.push(newValue ? newValue : {});
  } else if (newValue) {
    notifications[notificationIndex] = newValue;
  }
  campaign[CAMPAIGN.NOTIFICATIONS] = notifications;
  return campaign;
};

// removes a notification from the notification array of a campaign
// also remove the notification attribute entirely if campaign.notifications === []
export const removeNotificationAtIndex = (campaign, notificationIndex) => {
  if (campaign && campaign[CAMPAIGN.NOTIFICATIONS]) {
    campaign[CAMPAIGN.NOTIFICATIONS].splice(notificationIndex, 1);
  }
  if (!campaign?.[CAMPAIGN.NOTIFICATIONS]?.length) {
    delete campaign[CAMPAIGN.NOTIFICATIONS];
  }
  return campaign;
};

// update the to, cc, or bcc field with an array of values (general) or field name (personalized)
export const updateRecipientField = (
  campaign,
  notificationIndex,
  recipientType,
  newValue,
  hasCsvFile
) => {
  console.log({newValue});
  
  console.log({recipientType});
  
  const campaignType = getCampaignType(campaign, notificationIndex);
  console.log({campaignType});
  
  let recipientFieldName;
  if (
    campaignType === CAMPAIGN_TYPES.general.value &&
    campaign.general_data_source_type === "manual"
  ) {
    // if a general campaign
    recipientFieldName = UI_DATA.MANUAL_RECIPIENTS[recipientType];
    console.log({recipientFieldName});
    
    if (recipientType === RECIPIENTS.TO) {
      campaign = updateManualToRecipients({ ...campaign }, newValue);
    } else {
      // update a constant mapping for cc/bcc
      campaign = updateMapping(
        campaign,
        notificationIndex,
        recipientFieldName,
        typeof newValue === "object" ? newValue : [newValue],
        MAPPING.CONSTANT
      );
    }
  } else {
    // if a personalized campaign
    newValue = Array.isArray(newValue) ? "" : newValue;
    recipientFieldName = newValue?.trim();
  }
  console.log({recipientFieldName});
  
  // update recipient configuration, regardless of campaign type
  campaign = updateRecipientConfig(
    campaign,
    notificationIndex,
    recipientType,
    recipientFieldName,
    newValue
  );
  return campaign;
};

/*
"recipients": [
                {
                    "type": "to",
                    "field": [
                        {
                            "source_name": "file1.csv",
                            "source_field": "CSV_TO"
                        },
                        {
                            "source_name": "file1.csv",
                            "source_field": "CSV_TO"
                        },
                        {
                            "source_name": "manual_data_to",
                            "source_field": "manual_data_to"
                        }
                    ]
                }
              ]
*/
// update the to, cc, or bcc field with an array of values (manual) or field name (CSV)
export const updateRecipientFieldV2 = (
  campaign,
  notificationIndex,
  recipientType,
  newValue,
  dataSourceType
) => {
  console.log({recipientType});
  
  console.log({dataSourceType});
  
  const campaignDataSource = campaign[CAMPAIGN.DATA_SOURCE];
  const campaignType = campaignDataSource[DATA_SOURCE.CAMPAIGN_TYPE];
  let newRecipientField = {};
  switch(dataSourceType) {
    case DATA_SOURCE_TYPES.MANUAL:
      //newValue is string/array of email(s) for manual recipients
      let recipientFieldName = UI_DATA.MANUAL_RECIPIENTS[recipientType];
      if (recipientType === RECIPIENTS.TO) {
        campaign = updateManualToRecipientsV2({ ...campaign }, newValue);
      } else {
        const _newValue = newValue.source_field;
        // update a constant mapping for cc/bcc
        campaign = updateMapping(
          campaign,
          notificationIndex,
          recipientFieldName,
          typeof _newValue === "object" ? _newValue : [_newValue],
          MAPPING.CONSTANT
        );
      }
      newRecipientField = {
        "source_name": recipientFieldName,
        "source_field": recipientFieldName,
      }
      break;
    case DATA_SOURCE_TYPES.CSV:
      //newValue is object of { source_name, source_field }, source_name(csv filename) and source_field(csv header)
      if(newValue.source_field){
        newRecipientField = {
          "source_name": newValue.source_name,
          "source_field": newValue.source_field,
        };
      } else {
        newRecipientField = null;
      }
      break;
  }
  // update recipient configuration, regardless of campaign type
  campaign = updateRecipientConfigV2(
    campaign,
    notificationIndex,
    recipientType,
    campaignType,
    newRecipientField,
  );
  return campaign;
}

/**
 * Removes the recipient configuration for the specified recipientType from a notification.
 * @param {Function} recipientHandler - setter for recipient state.
 * @param {Object} campaign - The campaign object.
 * @param {Number} notificationIndex - The index of the notification.
 * @param {String} recipientType - The recipient type to remove ("to", "cc", "bcc").
 * @returns {Object} Updated campaign object.
 */
export const deleteRecipientConfigByType = (
  recipientHandler,
  campaign,
  notificationIndex,
  recipientType
) => {
  recipientHandler(null);
  const notification = getNotification(campaign, notificationIndex) || {};
  const recipientConfigsList = notification[NOTIFICATION.RECIPIENTS] || [];
  const recipientIndex = getConfigIndex(
    recipientConfigsList,
    CONFIGURATIONS.TYPE,
    recipientType
  );

  if (recipientIndex >= 0) {
    recipientConfigsList.splice(recipientIndex, 1);
    notification[NOTIFICATION.RECIPIENTS] = recipientConfigsList;
    campaign = updateOrCreateNotification(
      campaign,
      notificationIndex,
      notification
    );
  }
  return campaign;
};

export const updateManualToRecipientsV2 = (campaign, recipients) => {
  let dataSource = campaign[CAMPAIGN.DATA_SOURCE] || {};
  let recipientsArray = [];
  const dataSourceTypes = dataSource[DATA_SOURCE.DATA_SOURCE_TYPE] || [];
  if (recipients && recipients?.source_field?.length) {
    if(!dataSourceTypes.includes(DATA_SOURCE_TYPES.MANUAL)) {
      dataSourceTypes.push(DATA_SOURCE_TYPES.MANUAL);
    }
    if (typeof recipients.source_field === "object") {
      recipients.source_field.map((recipient) =>
        recipientsArray.push({
          [UI_DATA.MANUAL_RECIPIENTS.to]: recipient,
        })
      );
    } else {
      recipientsArray = [{ [UI_DATA.MANUAL_RECIPIENTS.to]: recipients }];
    }
    dataSource = {
      // [DATA_SOURCE.TYPE]: DATA_SOURCE_TYPES.MANUAL,
      [DATA_SOURCE.DATA_SOURCE_TYPE]: dataSourceTypes,
      [DATA_SOURCE.CONFIGURATIONS]: [
        {
          type: "inline",
          name: "data",
          value: recipientsArray,
        },
      ],
    };
  } else {
    //remove 'manual' data source type if it's empty
    if (dataSourceTypes.includes(DATA_SOURCE_TYPES.MANUAL)) {
      dataSourceTypes.splice(dataSourceTypes.indexOf(DATA_SOURCE_TYPES.MANUAL), 1);
    }
    dataSource = {
      // [DATA_SOURCE.TYPE]: DATA_SOURCE_TYPES.MANUAL,
      [DATA_SOURCE.DATA_SOURCE_TYPE]: dataSourceTypes,
      [DATA_SOURCE.CONFIGURATIONS]: [],
    };
  }
  campaign[CAMPAIGN.DATA_SOURCE] = dataSource;
  return campaign;
};

// update the value of campaign.notifications[x].configurations[y]
export const updateNotificationConfig = (
  campaign,
  notificationIndex,
  configName,
  newValue
) => {
  const notification = getNotification(campaign, notificationIndex) || {};
  const configs = notification[NOTIFICATION.CONFIGURATIONS] || [];
  const configIndex = getConfigIndex(configs, CONFIGURATIONS.NAME, configName);
  if (configIndex >= 0) {
    if (newValue && newValue.length) {
      configs[configIndex] = {
        ...configs[configIndex],
        [CONFIGURATIONS.VALUE]: newValue,
      };
    } else {
      configs.splice(configIndex, 1);
    }
  } else if (newValue && newValue.length) {
    configs.push({
      [CONFIGURATIONS.NAME]: configName,
      [CONFIGURATIONS.TYPE]: "inline",
      [CONFIGURATIONS.VALUE]: newValue,
    });
  }
  if (configs.length) {
    notification[NOTIFICATION.CONFIGURATIONS] = configs;
  } else {
    delete notification[NOTIFICATION.CONFIGURATIONS];
  }
  campaign = updateOrCreateNotification(
    campaign,
    notificationIndex,
    notification
  );

  return campaign;
};

// update the array of manual data in the data source object
const updateManualToRecipients = (campaign, recipients) => {
  let dataSource = campaign[CAMPAIGN.DATA_SOURCE] || {};
  console.log({dataSource});
  
  let recipientsArray = [];
  if (recipients && recipients.length) {
    if (typeof recipients === "object") {
      recipients.map((recipient) =>
        recipientsArray.push({
          [UI_DATA.MANUAL_RECIPIENTS.to]: recipient,
        })
      );
    } else {
      recipientsArray = [{ [UI_DATA.MANUAL_RECIPIENTS.to]: recipients }];
    }
    dataSource = {
      [DATA_SOURCE.TYPE]: DATA_SOURCE_TYPES.MANUAL,
      [DATA_SOURCE.CONFIGURATIONS]: [
        {
          type: "inline",
          name: "data",
          value: recipientsArray,
        },
      ],
    };
  } else {
    dataSource = {
      [DATA_SOURCE.TYPE]: DATA_SOURCE_TYPES.MANUAL,
      [DATA_SOURCE.CONFIGURATIONS]: [],
    };
  }
  campaign[CAMPAIGN.DATA_SOURCE] = dataSource;
  return campaign;
};

//OLD V1
// modify, create or remove one of the recipient configurations for a notification
const updateRecipientConfig = (
  campaign,
  notificationIndex,
  recipientType,
  recipientFieldName,
  newValue
) => {
  const notification = getNotification(campaign, notificationIndex) || {};
  const recipientConfigs = notification[NOTIFICATION.RECIPIENTS] || [];
  const recipientIndex = getConfigIndex(
    recipientConfigs,
    CONFIGURATIONS.TYPE,
    recipientType
  );
  if (recipientIndex >= 0) {
    if (newValue && newValue.length) {
      recipientConfigs[recipientIndex] = {
        ...recipientConfigs[recipientIndex],
        [RECIPIENTS.FIELD]: recipientFieldName,
      };
    } else {
      recipientConfigs.splice(recipientIndex, 1);
    }
  } else if (newValue && newValue.length) {
    recipientConfigs.push({
      [RECIPIENTS.TYPE]: recipientType,
      [RECIPIENTS.FIELD]: recipientFieldName,
    });
  }
  notification[NOTIFICATION.RECIPIENTS] = recipientConfigs;
  campaign = updateOrCreateNotification(
    campaign,
    notificationIndex,
    notification
  );
  return campaign;
};

//New V2
// modify, create or remove one of the recipient configurations for a notification
/**
 * 
 * @param {Object} campaign // campaign object
 * @param {Number} notificationIndex 
 * @param {String} recipientType // recipient type (e.g. "to", "cc", "bcc")
 * @param {String} campaignType // campaign type (e.g. "standard", "advanced")
 * @param {source_name: String, source_field: String} newRecipientField // new recipient field to add or update {source_name, source_field}
 * @returns 
 */
const updateRecipientConfigV2 = (
  campaign,
  notificationIndex,
  recipientType,
  campaignType,
  newRecipientField,
) => {
  console.log({newRecipientField});
  
  const notification = getNotification(campaign, notificationIndex) || {};
  //recipientConfigsList array -> [{type: "to", field: [{source_name, source_field}, {source_name, source_field}, ...]}, {type: "cc", field: [{source_name, source_field}]}, {type: "bcc", field: [{source_name, source_field}]}]
  const recipientConfigsList = notification[NOTIFICATION.RECIPIENTS] || [];
  console.log({recipientConfigsList});
  //find recipient conf index by matching the 'type' field
  const recipientIndex = getConfigIndex(
    recipientConfigsList,
    CONFIGURATIONS.TYPE,
    recipientType
  );

  // Helper to upsert a field for "to" type
  // If the recipient type is "to", it can have multiple fields, so we need to handle it differently
  const upsertToField = (fields, newField) => {
    if (!Array.isArray(fields)) fields = [];
    const idx = fields.findIndex(f => f.source_name === newField.source_name);
    if (idx >= 0) {
      fields[idx] = newField;
    } else {
      fields.push(newField);
    }
    return fields;
  };

  if (recipientIndex >= 0) { // recipient config already exists
    // Update existing recipient config
    if (newRecipientField) { // newRecipientField is provided
      // if the newRecipientField is not an array, convert it to an array
      if (recipientType === RECIPIENTS.TO) { // recipient type is "to"
        //recipientConfigsList[recipientIndex] -> {type: "to", field: [{source_name, source_field}
        //recipientConfigsList[recipientIndex][RECIPIENTS.FIELD] -> [{source_name, source_field}]
        recipientConfigsList[recipientIndex][RECIPIENTS.FIELD] = upsertToField(
          recipientConfigsList[recipientIndex][RECIPIENTS.FIELD],
          newRecipientField
        );
      } else { // recipient type is not "to"
        // If the recipient type is not "to", set the field to an array with the new newRecipientField
        recipientConfigsList[recipientIndex] = {
          ...recipientConfigsList[recipientIndex],
          [RECIPIENTS.FIELD]: [newRecipientField],
        };
      }
    } else { // newRecipientField is not provided
      // Remove the recipient config if newRecipientField is empty
      recipientConfigsList.splice(recipientIndex, 1);
    }
  } else if (newRecipientField) { // newRecipientField is provided
    // Create a new recipient config
    recipientConfigsList.push({
      [RECIPIENTS.TYPE]: recipientType,
      [RECIPIENTS.FIELD]: [newRecipientField],
    });
  }

  notification[NOTIFICATION.RECIPIENTS] = recipientConfigsList;
  campaign = updateOrCreateNotification(
    campaign,
    notificationIndex,
    notification
  );
  return campaign;
};

/**
 * Returns the recipient field array for the given recipient type from a campaign's notification.
 * @param {Object} campaign - The campaign object.
 * @param {Number} notificationIndex - The index of the notification.
 * @param {String} recipientType - The recipient type ("to", "cc", "bcc").
 * @returns {Array|undefined} The recipient field array or undefined if not found.
 */
export const getRecipientFields = (campaign, notificationIndex, recipientType) => {
  const notifications = campaign?.notifications || [];
  const notification = notifications[notificationIndex];
  if (!notification) return null;
  const recipients = notification[NOTIFICATION.RECIPIENTS] || [];
  const recipient = recipients.find((recipient) => recipient[RECIPIENTS.TYPE] === recipientType);
  return recipient?.[RECIPIENTS.FIELD] || null;
};

/**
 * Deletes recipient fields from a campaign's notification recipients array based on source_name.
 * @param {Object} campaign - The campaign object.
 * @param {Number} notificationIndex - The index of the notification.
 * @param {String} recipientType - The recipient type ("to", "cc", "bcc").
 * @param {String} sourceName - The source_name to match and remove.
 * @returns {Object} Updated campaign object.
 */
export const deleteRecipientConfigFieldsbySourceName = (campaign, notificationIndex, recipientType, sourceName) => {
  console.log(`deleteRecipientConfigFieldsbySourceName, notificationIndex:${notificationIndex}, recipientType:${recipientType}, sourceName:${sourceName}`);
  
  const notification = getNotification(campaign, notificationIndex) || {};
  const recipientConfigsList = notification[NOTIFICATION.RECIPIENTS] || [];
  const recipientIndex = getConfigIndex(
    recipientConfigsList,
    CONFIGURATIONS.TYPE,
    recipientType
  );

  if (recipientIndex >= 0) {
    let fields = recipientConfigsList[recipientIndex][RECIPIENTS.FIELD] || [];
    console.log({fields});
    console.log({sourceName});
    
    
    // Remove all fields with matching source_name
    fields = fields.filter(field => field.source_name !== sourceName);
    if (fields.length) {
      recipientConfigsList[recipientIndex][RECIPIENTS.FIELD] = fields;
    } else {
      // Remove the entire recipient config if no fields remain
      recipientConfigsList.splice(recipientIndex, 1);
    }
    notification[NOTIFICATION.RECIPIENTS] = recipientConfigsList;
    campaign = updateOrCreateNotification(
      campaign,
      notificationIndex,
      notification
    );
  }
  return campaign;
};

/**
 * Gets the "to" field value from the recipients of a notification.
 * @param {Object} campaign 
 * @param {Number} notificationIndex
 * @param {String} fileName - The name of the CSV file.
 * @returns 
 */
export const getSelectedToFieldHeaderForCSVFile = (campaign, notificationIndex) => {
  return getRecipientFields(campaign, notificationIndex, RECIPIENTS.TO);
};

/**
 * Checks if a campaign is a standard campaign.
 * @param {Object} campaign 
 * @param {Number} notificationIndex 
 * @returns {Boolean}
 */
export const isStandardCampaign = (campaign, notificationIndex) => {
  return getCampaignType(campaign, notificationIndex) === CAMPAIGN_TYPES.general.value;
}
/**
 * Checks if a campaign has recipient fields.
 * @param {Object} campaign 
 * @param {Number} notificationIndex 
 * @returns {Boolean}
 */
export const hasRecipientFields = (campaign, notificationIndex) => {
  const to = getRecipientFields(campaign, notificationIndex, RECIPIENTS.TO);
  const cc = getRecipientFields(campaign, notificationIndex, RECIPIENTS.CC);
  const bcc = getRecipientFields(campaign, notificationIndex, RECIPIENTS.BCC);
  return !_.isEmpty(to) || !_.isEmpty(cc) || !_.isEmpty(bcc);
}

export const updateMapping = (
  campaign,
  notificationIndex,
  mappingTemplateName,
  newValue,
  mappingType,
  srcFieldName
) => {
  const notification = getNotification(campaign, notificationIndex) || {};
  const mappings = notification[NOTIFICATION.MAPPING] || [];
  const mappingIndex = getConfigIndex(
    mappings,
    MAPPING.TEMPLATE_NAME,
    mappingTemplateName
  );
  const mappingFieldProperty =
    mappingType === MAPPING.CIP ? MAPPING.CIP_FIELD : MAPPING.CONSTANT_VALUE;
  if (mappingIndex >= 0) {
    if (newValue && newValue.length) {
      let updatedMapping = {
        ...mappings[mappingIndex],
      };
      if (mappingType) {
        updatedMapping = {
          ...updatedMapping,
          [MAPPING.RULE]: {
            [MAPPING.TYPE]: mappingType,
            [mappingFieldProperty]: newValue,
          },
        };
      }
      mappings[mappingIndex] = updatedMapping;
      if (srcFieldName) {
        mappings[mappingIndex] = {
          ...mappings[mappingIndex],
          [MAPPING.SRC_NAME]: srcFieldName,
        };
      }
    } else {
      mappings.splice(mappingIndex, 1);
    }
  } else if (newValue && newValue.length) {
    let newMapping = {
      [MAPPING.TEMPLATE_NAME]: mappingTemplateName,
    };
    if (mappingType) {
      newMapping = {
        ...newMapping,
        [MAPPING.RULE]: {
          [MAPPING.TYPE]: mappingType,
          [mappingFieldProperty]: newValue,
        },
      };
    }
    if (srcFieldName) {
      newMapping[MAPPING.SRC_NAME] = srcFieldName;
    }
    mappings.push(newMapping);
  }
  if (mappings.length) {
    notification[NOTIFICATION.MAPPING] = mappings;
  } else {
    delete notification[NOTIFICATION.MAPPING];
  }

  campaign = updateOrCreateNotification(
    campaign,
    notificationIndex,
    notification
  );
  return campaign;
};



export const getEmbeddedTemplates = (campaign) => {
  return campaign?.[CAMPAIGN.NOTIFICATIONS]?.map((notification) => {
    return notification[NOTIFICATION.TEMPLATE];
  });
};

export const removeEmbeddedTemplates = async (campaign) => {
  await campaign?.[CAMPAIGN.NOTIFICATIONS]?.forEach((notification, index) => {
    delete notification[NOTIFICATION.TEMPLATE];
    campaign[CAMPAIGN.NOTIFICATIONS][index] = notification;
  });
  return campaign;
};

export const addEmbeddedTemplates = async (campaign, templates = []) => {
  await campaign?.[CAMPAIGN.NOTIFICATIONS]?.forEach((notification, index) => {
    notification[NOTIFICATION.TEMPLATE] = templates[index];
    campaign[CAMPAIGN.NOTIFICATIONS][index] = notification;
  });
  return campaign;
};

export const updateCronTrigger = (campaign, cronExp, isOneTime = true) => {
  if (campaign) {
    if (cronExp) {
      campaign[CAMPAIGN.TRIGGER] = {
        [TRIGGER.TYPE]: TRIGGER.CRON,
        [TRIGGER.STATE]: TRIGGER.ACTIVE,
        [TRIGGER.CONFIG]: {
          [TRIGGER.CRON_EXP]: cronExp,
        },
        [TRIGGER.IS_ONE_TIME]: isOneTime,
      };
    } else if (campaign[CAMPAIGN.TRIGGER]) {
      campaign[CAMPAIGN.TRIGGER] = {
        ...campaign[CAMPAIGN.TRIGGER],
        [TRIGGER.STATE]: TRIGGER.INACTIVE,
      };
    }
  }
  return campaign;
};

// helper function that checks if all previous required steps are complete
// accepts an array of steps, the current active step index and selected campaign
// returns true of false
export const previousRequiredStepsComplete = (
  steps,
  activeStepIndex,
  campaign
) => {
  let complete = true;
  let i = 0;
  while (i < activeStepIndex && complete) {
    if (steps[i].required) {
      complete = steps[i].isComplete(campaign);
    }
    i = i + 1;
  }
  return complete;
};

export const getStepperConfig = (campaignToSelect, channel, campaignType) => {
  let stepper;
  if(campaignToSelect?.[CAMPAIGN.IS_SYSTEM_NOTIFICATIONS]) {
    stepper = SYSTEM_NOTIFICATIONS_DEFAULT_FLOW;
  } else {
    stepper = DEFAULT_FLOW;
  }
  if (channel) {
    if(campaignToSelect?.[CAMPAIGN.IS_SYSTEM_NOTIFICATIONS]) {
      stepper = SYSTEM_NOTIFICATIONS_STEPPER[channel];
    } else {
      stepper = STEPPER[channel];
    }
    const stepperTypes = Object.keys(stepper);
    if (stepperTypes?.includes(campaignType)) {
      stepper = stepper[campaignType];
    } else {
      stepper = stepper[stepperTypes?.[0]];
    }
  }
  return stepper;
};

// determine what page to land the user on when a campaign is opened
export const getCurrentStepIndex = (campaign, steps) => {
  let current = 0;
  if (steps?.length) {
    while (current < steps.length - 1 && steps[current].isComplete(campaign)) {
      ++current;
    }
  }
  return current;
};

// helper function that returns the index that a particular config is at in a configurations array
export const getConfigIndex = (configs, attributeToMatch, configValue) => {
  const isConfig = (config) => config[attributeToMatch] === configValue;
  return configs?.findIndex(isConfig);
};

export const autoMapRecipientField = (
  campaign,
  notificationIndex,
  recipientField
) => {
  console.log({notificationIndex});
  console.log(getNotification(campaign, notificationIndex));
  const notification = getNotification(campaign, notificationIndex);
  if (notification && recipientField) {
    let mappings = notification[NOTIFICATION.MAPPING] || [];
    console.log({mappings});
    
    let defaultCIPFieldMapping = CIP_FIELDS.EMAIL.variable;
    let recipientMapping = {
      [MAPPING.SRC_NAME]: recipientField,
      [MAPPING.TEMPLATE_NAME]: recipientField,
      [MAPPING.RULE]: {
        [MAPPING.TYPE]: MAPPING.CIP,
        [MAPPING.CIP_FIELD]: CIP_FIELDS.EMAIL.variable,
      },
    };
    if (notification.type === NOTIFICATION_CHANNELS.teams.value) {
      recipientMapping = {
        [MAPPING.SRC_NAME]: recipientField,
        [MAPPING.TEMPLATE_NAME]: recipientField,
        [MAPPING.RULE]: {
          [MAPPING.TYPE]: MAPPING.CIP,
          [MAPPING.CIP_FIELD]: CIP_FIELDS.UPN.variable,
        },
      };
      defaultCIPFieldMapping = CIP_FIELDS.UPN.variable;
    }
    const mappingIndex = mappings.findIndex(
      (mapping) =>
        mapping[MAPPING.SRC_NAME] === recipientMapping[MAPPING.SRC_NAME] &&
        mapping[MAPPING.TEMPLATE_NAME] ===
          recipientMapping[MAPPING.TEMPLATE_NAME]
    );
    if (mappingIndex < 0) {
      mappings.push(recipientMapping);
    } else if (
      mappings[mappingIndex]?.[MAPPING.RULE][MAPPING.CIP_FIELD] !==
      defaultCIPFieldMapping
    ) {
      mappings[mappingIndex] = recipientMapping;
    } else {
      // no updates needed
      return campaign;
    }
    notification[NOTIFICATION.MAPPING] = mappings;
    campaign[CAMPAIGN.NOTIFICATIONS][notificationIndex] = notification;
  }
  return campaign;
};

export const removeMapping = (
  campaign,
  notificationIndex,
  srcName,
  templateName
) => {
  const notification = getNotification(campaign, notificationIndex);
  if (notification) {
    let mappings = notification[NOTIFICATION.MAPPING];
    const mappingIndex = mappings?.findIndex(
      (mapping) =>
        mapping[MAPPING.SRC_NAME] === srcName &&
        mapping[MAPPING.TEMPLATE_NAME] === templateName
    );
    if (mappingIndex > -1) {
      mappings.splice(mappingIndex, 1);
      if (mappings?.length) {
        notification[NOTIFICATION.MAPPING] = mappings;
      } else {
        delete notification[NOTIFICATION.MAPPING];
      }
      campaign[CAMPAIGN.NOTIFICATIONS][notificationIndex] = notification;
    }
  }
  return campaign;
};

// removes a notifications recipient and recipient-related mappings
export const resetRecipients = (campaign, notificationIndex) => {
  if (campaign) {
    const recipients = getRecipientsFieldValues(campaign, notificationIndex);
    [RECIPIENTS.TO, RECIPIENTS.CC, RECIPIENTS.BCC].forEach((type) => {
      const originalRecipient = recipients?.[type];
      if (originalRecipient) {
        campaign = updateRecipientField(
          campaign,
          notificationIndex,
          type,
          null
        );
        campaign = removeMapping(
          campaign,
          notificationIndex,
          originalRecipient,
          originalRecipient
        );
      }
    });
  }
  return campaign;
};

// Remove any csv mappings that no longer apply to current dataSourceHeadings
export const removeUnusedMappings = (campaign, dataSourceHeadings) => {
  
  campaign?.[CAMPAIGN.NOTIFICATIONS]?.map((notification, index) => {
    let unused = [];
    notification?.[NOTIFICATION.MAPPING]?.map((mapping) => {
      if (
        !mapping[MAPPING.RULE] ||
        mapping[MAPPING.RULE][MAPPING.TYPE] !== MAPPING.CONSTANT
      ) {
        const match = dataSourceHeadings?.find(
          (heading) => heading.value === mapping[MAPPING.SRC_NAME]
        );
        if (!match) {
          unused.push(mapping);
        }
      }
    });
    unused?.forEach((unusedMapping) => {
      campaign = removeMapping(
        campaign,
        index,
        unusedMapping[MAPPING.SRC_NAME],
        unusedMapping[MAPPING.TEMPLATE_NAME]
      );
    });
  });
  return campaign;
};

// add a field to the fieldErrors array if true, remove it otherwise
export const updateFieldErrors = (
  fieldName,
  error,
  fieldErrors,
  setFieldErrors
) => {
  let errors = [...fieldErrors];
  if (error) {
    if (!errors.includes(fieldName)) {
      errors.push(fieldName);
      setFieldErrors(errors);
    }
  } else if (errors.includes(fieldName)) {
    let errorIndex = errors.findIndex((field) => field === fieldName);
    if (errorIndex > -1) {
      errors.splice(errorIndex, 1);
      setFieldErrors(errors);
    }
  }
};

// determine if a given step should have an error state
// a step has errors if fields in that step are included in the fieldErrors array
export const checkForStepError = (step, fieldErrors) => {
  let error = false;
  let i = 0;
  while (!error && i < step.fields?.length) {
    error = fieldErrors?.includes(step.fields[i]);
    i++;
  }
  return error;
};

//Module to make the campaign backward compatible before loading into the states
export const makeCampaignBackwardCompatibile = (campaign, notificationIndex) => {
  let _campaign = campaign;
  const channel = getChannel(
    getNotification(campaign, notificationIndex)
  );
  const campaignType = getCampaignType(campaign, notificationIndex);
  //if email channel and advanced campaign
  if(channel === NOTIFICATION_CHANNELS.mail.value && campaignType === CAMPAIGN_TYPES.personalized.value){
    _campaign = makeCampaignBackwardCompatibileForIncludeUnsubscribeField(campaign, notificationIndex);
  }
  return _campaign;
}

export const makeCampaignBackwardCompatibileForIncludeUnsubscribeField = (campaign, notificationIndex) => {
  let updatedCampaign = campaign;
  const configurations = getConfigurationFieldValues(campaign, notificationIndex);
  const hasExternalUsers = configurations[EXTERNAL_USER_OPTIONS_CONFIGS.INCLUDE_UNSUBSCRIBE_LINK];
  //if campaign does not have includeUnsubscribeLink config value (which is madatory in new campaigns)
  if(hasExternalUsers !== "true" && hasExternalUsers !== "false") {
    //set it to default value 'false'
    updatedCampaign = updateNotificationConfig(
      campaign,
      notificationIndex,
      EXTERNAL_USER_OPTIONS_CONFIGS.INCLUDE_UNSUBSCRIBE_LINK,
      "false"
    );
  }
  return updatedCampaign;
}

export const formatDateToCustom = (date) => {
  if (!date) return '';
  return moment(date).format('MMMM D, YYYY, h:mmA');
};

export const getLastSavedTime = (campaign) => {
  const lastSavedTime = campaign[CAMPAIGN.DATE_UPDATED];
  if (lastSavedTime) {
      return formatDateToCustom(lastSavedTime);
  } else {
      return formatDateToCustom(campaign[CAMPAIGN.DATE_CREATED]);
  }
}

export const getMaxDate = () => {
  // a user can select a date less than one year in the future
  // ex: current date is July 9, 2021 -> can select July 8, 2022 but cannot select July 9, 2022
  const today = moment.now();
  const max = moment(today).add(364, "days");
  return max;
};

export const validateTime = (value) => {
  // validate that selected time is more than 1 hour from now
  const hoursUntil = moment
    .duration(moment(value).diff(moment.now()))
    .asHours();
  const valid = hoursUntil >= 1;
  // toggleDateError(!valid);
  return valid;
};

export const getDate = (selectedCampaign) => {
  let date;
  if (selectedCampaign) {
    date = getDateFromCron(selectedCampaign);
  }
  if (!date) {
    date = getDefaultTime();
  }
  return date;
};

export const getDefaultTime = () => {
  let today = moment.now(); // the user's current time in local timezone
  let minutes;
  let hours;
  // default time should be at least 1 hour in the future
  // use 30 minute increments for default time
  if (moment(today).minute() > 30) {
    // ex: current time is 11:36 -> round up to 1:00
    hours = moment(today).hours() + 2;
    minutes = 0;
  } else {
    hours = moment(today).hours() + 1;
    if (moment(today).minutes() === 0) {
      // ex: current time is 11:00 -> return 12:00
      minutes = 0;
    } else {
      // ex: current time is 11:15 -> round up to 12:30
      minutes = 30;
    }
  }
  const date = moment(today).set("hour", hours).set("minute", minutes);
  return date;
};

export const getCsvFilename = (file) => {
  if(!file) return null;
  return file.actualFilename || file.name; 
}

// returns the width of the progress bar based on the progress percentage and the total width of the bar
// progress is a number between 0 and 100, barWidth is the total width of the progress bar in pixels
// returns the width of the progress bar in pixels
export const getProgressWidth = (progress, barWidth = 0) => {
  return Math.ceil((progress/100) * barWidth);
}

/**
 * Updates or creates an SSOT mapping for a notification
 * @param {Object} campaign - The campaign object
 * @param {Number} notificationIndex - Index of the notification
 * @param {String} mappingTemplateName - Template name for the mapping
 * @param {Object} ssotConfig - SSOT configuration object with filter, ByPassDLExpansion, ByPassDeDupe, SsotValidation
 * @param {String} srcFieldName - Optional source field name
 * @returns {Object} Updated campaign object
 */
export const updateSSOTMapping = (
  campaign,
  notificationIndex,
  // mappingTemplateName,
  ssotConfig,
  // srcFieldName
) => {
  const notification = getNotification(campaign, notificationIndex) || {};
  const mappings = notification[NOTIFICATION.MAPPING] || [];
  
  // Find existing SSOT mapping by checking if mapping.rule.SSOT exists
  const ssotMappingIndex = mappings.findIndex(mapping => 
    mapping[MAPPING.RULE]?.SSOT !== undefined
  );
  
  // Check if we have valid SSOT config
  const hasValidSSOTConfig = ssotConfig && (
    ssotConfig.filter || 
    ssotConfig.byPassDLExpansion !== undefined || 
    ssotConfig.byPassDeDupe !== undefined || 
    ssotConfig.ssotValidation !== undefined
  );
  
  if (ssotMappingIndex >= 0) {
    // SSOT mapping already exists
    if (hasValidSSOTConfig) {
      // Update existing SSOT mapping
      let updatedMapping = {
        ...mappings[ssotMappingIndex],
        // [MAPPING.TEMPLATE_NAME]: mappingTemplateName,
        [MAPPING.RULE]: {
          [MAPPING.TYPE]: "constant",
          SSOT: {
            ...ssotConfig
          }
        }
      };
      
      // if (srcFieldName) {
      //   updatedMapping[MAPPING.SRC_NAME] = srcFieldName;
      // }
      
      mappings[ssotMappingIndex] = updatedMapping;
    } else {
      // Remove existing SSOT mapping if no valid config provided
      // mappings.splice(ssotMappingIndex, 1);
    }
  } else if (hasValidSSOTConfig) {
    // Create new SSOT mapping
    let newSSOTMapping = {
      // [MAPPING.TEMPLATE_NAME]: mappingTemplateName,
      [MAPPING.RULE]: {
        [MAPPING.TYPE]: "constant",
        SSOT: {
          ...ssotConfig
        }
      }
    };
    
    // if (srcFieldName) {
    //   newSSOTMapping[MAPPING.SRC_NAME] = srcFieldName;
    // }
    
    mappings.push(newSSOTMapping);
  }
  
  // Update notification with mappings
  if (mappings.length) {
    notification[NOTIFICATION.MAPPING] = mappings;
  } else {
    delete notification[NOTIFICATION.MAPPING];
  }
  
  campaign = updateOrCreateNotification(
    campaign,
    notificationIndex,
    notification
  );
  
  return campaign;
};

/**
 * Gets the SSOT mapping configuration for a notification
 * @param {Object} campaign - The campaign object
 * @param {Number} notificationIndex - Index of the notification
 * @returns {Object|null} SSOT configuration object or null if not found
 */
export const getSSOTMapping = (campaign, notificationIndex) => {
  const notification = getNotification(campaign, notificationIndex);
  if (!notification) return null;
  
  const mappings = notification[NOTIFICATION.MAPPING] || [];
  const ssotMapping = mappings.find(mapping => 
    mapping[MAPPING.RULE]?.SSOT !== undefined
  );
  
  return ssotMapping?.[MAPPING.RULE]?.SSOT || null;
};

/**
 * Removes SSOT mapping from a notification
 * @param {Object} campaign - The campaign object
 * @param {Number} notificationIndex - Index of the notification
 * @returns {Object} Updated campaign object
 */
export const removeSSOTMapping = (campaign, notificationIndex) => {
  const notification = getNotification(campaign, notificationIndex) || {};
  const mappings = notification[NOTIFICATION.MAPPING] || [];
  
  const ssotMappingIndex = mappings.findIndex(mapping => 
    mapping[MAPPING.RULE]?.SSOT !== undefined
  );
  
  if (ssotMappingIndex >= 0) {
    mappings.splice(ssotMappingIndex, 1);
    
    notification[NOTIFICATION.MAPPING] = mappings;
    
    campaign = updateOrCreateNotification(
      campaign,
      notificationIndex,
      notification
    );
  }
  
  return campaign;
};